import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { signUpUserInPoolAmplify } from '../../services/ampifyAdminService';
import { ADMIN_ACTIONS } from '../../services/cognitoAdminService';
import UserManagmentList from '../../components/UserManagment/UserManagmentList';
import CreateUserDialog from '../../components/UserManagment/CreateUserDialog';
import UpdateUserDialog from '../../components/UserManagment/UpdateUserDialog';
import { handleAwsError } from '../../services/awsErrorHandler';

function UserManagment({ userData, props }) {

  const [adminUsers, setAdminUsers] = useState([]);
  const [isAdminUsersUpdate, setIsAdminUsersUpdate] = useState(false);
  const [dialogCreateUser, setDialogCreateUser] = useState(false);
  const [userForUpdate, setUserForUpdate] = useState(null);
  const [isDialogOpen,setDialogOpen] = useState(false);

  useEffect(() => {
    if (userData && !isAdminUsersUpdate) {
      setIsAdminUsersUpdate(false);
      fetchAdminUsers();
    }
  }, [userData, adminUsers]);

  const fetchAdminUsers = async () => {
    setIsAdminUsersUpdate(true);
    const usersList = await signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.LIST_USERS);
    const transformedUsers = usersList?.Users?.map(user => {
      const attributes = Object.fromEntries(user.Attributes.map(attr => [attr.Name, attr.Value]));
      return {
        email: attributes?.email || '',
        emailVerified: attributes?.email_verified === 'true',
        role: attributes['custom:role'] || '',
        sub: attributes?.sub || '',
        username: user?.Username,
        enabled: user?.Enabled,
        userStatus: user?.UserStatus,
        createdAt: user?.UserCreateDate,
        updatedAt: user?.UserLastModifiedDate,
      };
    });
    if (transformedUsers) {
      if (isAdminUsersUpdate) {
        setIsAdminUsersUpdate(false);
      }
      setAdminUsers(transformedUsers);
    }
  };

  const createAdminUser = async (newUser) => {
    const usersList = await signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.CREATE_USER, newUser?.email, newUser?.password, newUser?.role);
    if (usersList?.isError) {
      alert(handleAwsError(usersList?.error));
    }
    else{
      fetchAdminUsers();
    }
  }

  const handleCreateUser = (newUser) => {
    createAdminUser(newUser);
  };

  const hadnleOnUpdateUser = async (updatedUser) => {    
    if(updatedUser?.status === "Enable")
    {
      const updateUserEnabled = await signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.ENABLE_USER, updatedUser?.email, updatedUser?.password, updatedUser?.role);
    }
    else if (updatedUser?.status === "Disable")
    {
      const updateUserDisabled = await signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.DISABLE_USER, updatedUser?.email, updatedUser?.password, updatedUser?.role);
    }
    
    const updateUserRole = await signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.UPDATE_USER, updatedUser?.email, updatedUser?.password, updatedUser?.role);
    if (updateUserRole) {
       fetchAdminUsers();
       setUserForUpdate(null);
    }
  }

  const hadnleOnDeleteUser = async (deletedUser) => {
    const usersList = await signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.DELETE_USER, deletedUser?.email, deletedUser?.password, deletedUser?.role);
    if (usersList?.isError) {
      alert(handleAwsError(usersList?.error));
    }
    else{
      fetchAdminUsers();
      setUserForUpdate(null);
    }
  }

  const updateToserver = () => {

  }

  return (
    <div style={styles.container}>
      <Box sx={{ flex: 1, height: "100%", padding: 4, marginTop: 2 }}>

        {/* Title + Create + Update button in a row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0,
            px: 2
          }}>

          </Box>

          {/* Create */}
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0,
            px: 2
          }}>
            <Button
              variant="contained"
              color="success"
              sx={{ borderRadius: 2, textTransform: "none", px: 4 }}
              onClick={() => {
                console.log("create button clicked!! : ")
                setDialogCreateUser(true);
              }}
            >
              Create User
            </Button>

            {/* Update */}
            {/* <Button
              variant="contained"
              color="error"
              sx={{ borderRadius: 2, textTransform: "none", px: 4, ml: 4 }}
              onClick={() => {
                updateToserver();
              }}
            >
              Update
            </Button> */}
          </Box>

        </Box>

        {adminUsers &&
          <Box sx={{ p: 2 }}>
            {<UserManagmentList adminUsers={adminUsers} setDialogOpen={setDialogOpen} setUserForUpdate={setUserForUpdate} />}
          </Box>}
      </Box>

      <CreateUserDialog
        openCreateUserDialog={dialogCreateUser}
        onCloseCreateUserDialog={() => setDialogCreateUser(false)}
        onCreateUserDialogClick={handleCreateUser}
      />

      <UpdateUserDialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        user={userForUpdate}
        onUpdate={(updatedUser) => {
          hadnleOnUpdateUser(updatedUser);
        }}
        onDelete={(deletedUser) => {
          hadnleOnDeleteUser(deletedUser);
        }}
      />
    </div>
  );
}

// Simple inline styles
const styles = {
  container: {
    padding: '40px',
    textAlign: 'center',
  },
  title: {
    fontSize: '36px',
    marginBottom: '10px',
  },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => ({

});

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({

});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(UserManagment);